import { BackstageUserIdentity } from '@backstage/core-plugin-api';

import { unknownName } from '../utils';

export function persistFormState(id: string, payload: any) {
  localStorage.setItem(id, JSON.stringify(payload));
}

export function clearFormState(id: string) {
  localStorage.removeItem(id);
}

export function restoreFormState(id: string): Record<string, any> {
  try {
    const payload = localStorage.getItem(id);
    if (!payload) {
      return {};
    }
    return JSON.parse(payload);
  } catch (err) {
    return {};
  }
}

export function getIdentiyRef(identity: BackstageUserIdentity | undefined) {
  return identity?.userEntityRef || unknownName;
}

export function createFormPersistenceKey(
  identity: BackstageUserIdentity | undefined,
  templateRef: string,
  product: string = unknownName,
) {
  const userRef = getIdentiyRef(identity);
  return `${userRef}/${templateRef}/${product}`;
}

export function loadStateFromUrl() {
  try {
    const url = new URL(document.location.href);
    const formData = url.searchParams.get('formData');
    return formData ? JSON.parse(formData) : {};
  } catch {
    return {};
  }
}
